module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy Springer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nancy Springer is the award-winning author of more than fifty books, including the Enola Holmes and Rowan Hood series and a plethora of novels for all ages, spanning fantasy, mystery, magic realism, and more. She received the James Tiptree, Jr. Award for "), _c('I', [_vm._v("Larque on the Wing")]), _vm._v(" and the Edgar Award for her juvenile mysteries "), _c('I', [_vm._v("Toughing It ")]), _vm._v("and "), _c('I', [_vm._v("Looking for Jamie Bridger")]), _vm._v(", and she has been nominated for numerous other honors. Springer currently lives in the Florida Panhandle, where she rescues feral cats and enjoys the vibrant wildlife of the wetlands."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xuBjTB/tc-custom/9781497688735.jpg?1705549509398",
      "alt": "This image is the cover for the book Dusssie"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dusssie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Dusie is having a bad day of mythological proportions")]), _c('br'), _c('br'), _vm._v(" Dusie wakes up one morning to a hissing sound. As she catches her reflection in the mirror, she finds that her hair has turned into snakes. That’s right—"), _c('i', [_vm._v("snakes")]), _vm._v(". But her mom seems totally unfazed. That’s because underneath the turban, Dusie’s mom has a crown of vipers. She is an immortal gorgon—a kind of goddess—and had hoped Dusie wouldn’t inherit the family curse since her father was a mortal, but it looks like Dusie is stuck with it too."), _c('br'), _c('br'), _vm._v(" Middle school is tough enough without being cursed, and Dusie—or Dusssie, as the snakes call her—is about to learn that being half gorgon comes with its own set of challenges. She tries to keep her snakes hidden, but when a boy at school nearly blows her cover, Dusie is desperate to figure out a way to control her newfound powers. Growing up, with or without snakes for hair, isn’t kid stuff.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0